import { Alert, AlertTitle, Box, Snackbar } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReportPZ04Form from '../../common/ReportPZ04Form/ReportPZ04Form';
import {
  addReportPZ04Request,
  sendCreateMailPZ04,
} from '../../../redux/reportsPZ04Redux';

const AddReportPZ04 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [requestStatus, setRequestStatus] = useState('');
  const [alert, setAlert] = useState(false);

  const handleSubmit = async (data) => {
    setAlert(true);
    console.log(data);

    const res = await dispatch(addReportPZ04Request(data));
    await setRequestStatus(res.status);

    if (res.status === 201) {
      const data = {
        emailGroup: {
          messageType: 'PZ04_QUARANTINE',
          warehouseCode: res.data.warehouse,
        },
        subject: `Nowa niezgodność PZ04 - ${res.data.reportNumber}`,
        template: 'newReportPZ04',
        reportDetails: res.data,
      };
      const res2 = await dispatch(sendCreateMailPZ04(data));
      console.log(res2);
    }

    // if (res.status === 201) {
    //   await dispatch(sendCreateMail({ id: res.data.id }));
    // }
    // setTimeout(() => {
    //   navigate(`/details-pz04/${res.data.id}`);
    // }, 2000);
  };
  const handleClose = () => {
    setAlert(false);
  };

  return (
    <Box>
      {requestStatus === 201 && (
        <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            variant="filled"
            onClose={handleClose}
            severity="success"
            sx={{ width: '100%' }}
          >
            <AlertTitle>Success</AlertTitle>
            Pomyślnie dodano niezgodność
          </Alert>
        </Snackbar>
      )}
      {requestStatus === 500 && (
        <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            variant="filled"
            onClose={handleClose}
            severity="error"
            sx={{ width: '100%' }}
          >
            <AlertTitle>Error</AlertTitle>
            {t('common.serverError')}
          </Alert>
        </Snackbar>
      )}
      <ReportPZ04Form action={handleSubmit} actionText={t('pz04.addForm')} />
    </Box>
  );
};

export default AddReportPZ04;
